import { getToken } from "../../../utils/auth";
import { dev_baseUrl } from "../../../utils/var";

export const GetDefaultMaterials = async (serviceOfferingID, navigate) => {
  const accesstoken = getToken();
  if (accesstoken) {
    try {
      const queryParams = new URLSearchParams({
        serviceOfferingID: serviceOfferingID,
      }).toString();

      const response = await fetch(
        `${dev_baseUrl}/Service/getDefaultMaterials?${queryParams}`,
        {
          method: "GET",
          headers: {
            Authorization: `Bearer ${accesstoken}`,
            "Content-Type": "application/json",
          },
        }
      );

      const data = await response.json();

      if (!response.ok && !data.isError && data.statusCode === "Unauthorized") {
        navigate(`/login`);
      } else {
        return data;
      }
    } catch (error) {
      console.error("Network error:", error);
      return {
        isError: true,
        message: "An error occurred. Please try again later.",
        error: error,
      };
    }
  } else {
    console.warn("Access token is not available.");
    return { isError: true, message: "Access token is missing." };
  }
};

export const SaveDefaultMaterial = async (serviceOfferingID, material, navigate) => {
  const accesstoken = getToken();
  if (accesstoken) {
    try {
      let Payload = {
        defaultJobMaterialID: material.defaultJobMaterialID || 0,
        serviceOfferingID: serviceOfferingID,
        materialID: material.materialID,
        materialTypeID: material.materialTypeID,
        quantity: material.quantity,
        unitID: material.unitID,
        costPerUnit: material.costPerUnit,
        pricePerUnit: material.pricePerUnit,
      };

      const response = await fetch(
        `${dev_baseUrl}/Service/saveDefaultMaterial`,
        {
          method: "POST",
          headers: {
            Authorization: `Bearer ${accesstoken}`,
            "Content-Type": "application/json",
          },
          body: JSON.stringify(Payload),
        }
      );

      const data = await response.json();
      if (!response.ok && !data.isError && data.statusCode === "Unauthorized") {
        navigate(`/login`);
      } else {
        return data;
      }
    } catch (error) {
      console.error("Network error:", error);
      return {
        isError: true,
        message: "An error occurred. Please try again later.",
        error: error,
      };
    }
  } else {
    console.warn("Access token is not available.");
    return { form: "Access token is missing." };
  }
};

export const DeleteDefaultMaterial = async (defaultJobMaterialID, navigate) => {
  const accesstoken = getToken();
  if (accesstoken) {
    try {
      const response = await fetch(
        `${dev_baseUrl}/Service/deleteDefaultMaterial/${defaultJobMaterialID}`,
        {
          method: "DELETE",
          headers: {
            Authorization: `Bearer ${accesstoken}`,
            "Content-Type": "application/json",
          },
        }
      );

      const data = await response.json();

      if (!response.ok && !data.isError && data.statusCode === "Unauthorized") {
        navigate(`/login`);
      } else {
        return data;
      }
    } catch (error) {
      console.error("Network error:", error);
      return {
        isError: true,
        message: "An error occurred. Please try again later.",
        error: error,
      };
    }
  } else {
    console.warn("Access token is not available.");
    return { isError: true, message: "Access token is missing." };
  }
};
